import { ref } from '@vue/composition-api';

import type { SObject } from '@/types';
import type { CompareOverviewRecord } from '@/services/SalesforceService';

import useDI from './useDI';
import useSelected from './useSelected';
import { getSelectedFieldsBySObject as getSelectedCustomValueFieldsBySObject } from './useCustomValueFields';

export default function useSelectedRefresher() {
  const { container, Tokens } = useDI();
  const {
    selected,
    getBySObject: getSelectedFieldsBySObject,
    update: updateSelected,
  } = useSelected();

  const salesforceService = container.get(Tokens.SalesforceService);

  const refreshing = ref(false);

  async function refreshItems(items: CompareOverviewRecord[]) {
    refreshing.value = true;
    try {
      const refreshedItems = await Promise.all(
        items.map((item) => {
          return salesforceService.compareOne(
            item.SObject,
            item.Key,
            getSelectedCustomValueFieldsBySObject(item.SObject)
          );
        })
      );
      refreshedItems.forEach((item) => {
        updateSelected(item.Id, item);
      });
    } finally {
      refreshing.value = false;
    }
  }

  async function refresh() {
    await refreshItems(selected.value);
  }

  async function refreshBySObject(sobject: SObject) {
    await refreshItems(getSelectedFieldsBySObject(sobject));
  }

  return {
    refreshing,
    refresh,
    refreshBySObject,
  };
}
